import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../makeRequest";

export type UpdatePostRequest = {
  post_id: number; // required to identify which post to update
  post_author_en?: string;
  post_author_dv?: string;
  post_author_ar?: string;
  post_title_en?: string;
  post_title_dv?: string;
  post_title_ar?: string;
  post_content_en?: string;
  post_content_dv?: string;
  post_content_ar?: string;
  post_excerpt_en?: string;
  post_excerpt_dv?: string;
  post_excerpt_ar?: string;
  post_cover_image?: string;
  post_category?: string | string[];
  post_tags?: string[] | string;
  post_status?: "draft" | "published";
  is_featured_post?: boolean;
  is_published?: boolean;
};

async function updatePostApi(postData: UpdatePostRequest) {
  const data = await makeRequest("/api/admin/updatepost", {
    method: "PUT", // or PATCH if your API supports
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(postData),
  });

  if (!data) {
    const errorData = await data;
    throw new Error(errorData.error || "Failed to update post");
  }

  return data;
}

export function useUpdatePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePostApi,
    onSuccess: (data, variables) => {
      // Invalidate or update cached post data
      // For example, if you have a list query like ['posts']
      queryClient.invalidateQueries({ queryKey: ["posts"] });
      queryClient.invalidateQueries({ queryKey: ["adminallposts"] });
      console.log("Post updated successfully", data);
    },
    onError: (error: any) => {
      console.error("Failed to update post:", error);
    },
  });
}